{
  "info": "資訊",
  "warn": "警告",
  "success": "成功",
  "ok": "確定",
  "cancel": "取消",
  "save": "儲存",
  "yes": "是",
  "no": "否",
  "back": "返回",
  "browse": "瀏覽",
  "delete": "刪除",
  "remove": "移除",
  "loggedOut": "已登出",
  "error": {
    "title": "錯誤",
    "server": "伺服器回應錯誤，請稍後再試",
    "network": "網路連線異常，請檢查網路設定",
    "unknown": "發生未知的系統錯誤"
  },
  "sessionExpired": {
    "idle": {
      "summary": "閒置逾時",
      "detail": "因閒置過久已自動登出，請重新登入"
    },
    "tokenExpired": {
      "summary": "登入已過期",
      "detail": "您的登入已過期，請重新登入"
    }
  }
}